import { requestOTP, submitOTP, login, signup } from 'api/auth';
import { useMutation } from 'react-query';

function useRequestOTP() {
  return useMutation(requestOTP, {
    onError: (err) => {
      console.log(err.message);
    },
  })
}

function useSubmitOTP(){
  return useMutation(submitOTP, {
    onSuccess: () => {
      console.log('شما با موفقیت وارد شدید.');
    }
  });
}

function useLogin() {
  return useMutation(login, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: (res) => console.log('شما با موفقیت وارد شدید.', { variant: 'success' }),
  });
}

function useSignup() {
  return useMutation(signup, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('شما با موفقیت وارد شدید.', { variant: 'success' }),
  });
}


export {useRequestOTP, useSubmitOTP, useLogin, useSignup };

